import { render, staticRenderFns } from "./detail_index.vue?vue&type=template&id=8b3c463c&scoped=true"
import script from "./detail_index.vue?vue&type=script&lang=js"
export * from "./detail_index.vue?vue&type=script&lang=js"
import style0 from "./detail_index.vue?vue&type=style&index=0&id=8b3c463c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3c463c",
  null
  
)

export default component.exports